// extracted by mini-css-extract-plugin
export default {"nestedRow":"FinishedTicketItem_nestedRow__6Gf1b","transactionId":"FinishedTicketItem_transactionId__TG-Nr","pointer":"FinishedTicketItem_pointer__npIe9"};